import { reatomAsync, withDataAtom } from "@reatom/async";
import { withAbort } from "@reatom/framework";
import { ExportJobDto, ExportTaskIdDto } from "definitions/exporter";
import { API } from "src/api.ts";
import { withIsLoadingAtom } from "src/common/pipes";

export const EXPORT_JOBS_PAGE_SIZE = 20;

export type JobsWithChildren = ExportJobDto & {
  children?: ExportJobDto[];
};

export const getExportJobsRequest = reatomAsync(
  async (ctx, data: ExportTaskIdDto & { page?: number }) => {
    return API.exporterQueueApi
      .exportControllerGetMyExportJobsByTaskId(
        { taskId: data.id, limit: EXPORT_JOBS_PAGE_SIZE, page: data.page ?? 1 },
        {
          signal: ctx.controller.signal,
        },
      )
      .then((response) => {
        const data = response.data;

        const groupedJobs = new Map<string, JobsWithChildren>();

        data.data?.forEach((job) => {
          const isRepeat = job.id.includes("repeat");
          const jobId = isRepeat ? job.id.split(":")[1] : job.id;

          if (isRepeat) {
            if (job.status === "delayed" || job.status === "stopped") {
              if (!groupedJobs.has(jobId)) {
                groupedJobs.set(jobId, { ...job, id: jobId, children: [] });
              } else {
                groupedJobs.set(jobId, {
                  ...groupedJobs.get(jobId),
                  ...job,
                });
              }
            } else {
              if (!groupedJobs.has(jobId)) {
                groupedJobs.set(jobId, { ...job, id: jobId, children: [] });
              }
              groupedJobs.get(jobId)?.children?.push(job);
            }
          } else {
            if (!groupedJobs.has(jobId)) {
              groupedJobs.set(jobId, { ...job, children: [] });
            }
          }
        });

        return { data: [...groupedJobs.values()], totalItems: data.totalItems };
      });
  },
  "getExportJobsRequest",
).pipe(
  withDataAtom({ data: [], totalItems: 0 }),
  withAbort(),
  withIsLoadingAtom(),
);
